import { ValidatorFn } from '@angular/forms';
import { isValidCNPJ } from '@brazilian-utils/brazilian-utils';

export const cnpjValidator: ValidatorFn = ({ value }) => {
  return value && !isValidCNPJ(value, { version: 2 })
    ? { cnpj: { valid: false } }
    : null;
};
